import { render, staticRenderFns } from "./syncTask.vue?vue&type=template&id=2ec52b71&scoped=true"
import script from "./syncTask.vue?vue&type=script&lang=js"
export * from "./syncTask.vue?vue&type=script&lang=js"
import style0 from "./syncTask.vue?vue&type=style&index=0&id=2ec52b71&prod&lang=scss"
import style1 from "./syncTask.vue?vue&type=style&index=1&id=2ec52b71&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec52b71",
  null
  
)

export default component.exports